import {initMap, createClinicPLacemark} from '../../../components/clinics-map/index'
import {elementInViewport} from "../../../utils";

let mapLoadingStart = false;
const mapId = 'clinic-map-widget';
let mapContainer = document.querySelector('#' + mapId);
let map;

const run = () => {
    console.log('RUN clinics-map');
    bindBtnOpenMapTab();
    //resizeMap(mapContainer);

    /*window.addEventListener('resize', function(event) {
        resizeMap(mapContainer);
        if ('undefined' !== typeof map) {
            map.container.fitToViewport()
            // если задан transition в css у родительского блока
            setTimeout(() => {map.container.fitToViewport()}, 300);
        }
    }, true);*/

    let viewportTimer = setInterval(function() {
        if (mapLoadingStart) {
            clearTimeout(viewportTimer);
            return;
        }
        console.log('viewportTimer tick')
        if (!mapLoadingStart && elementInViewport(mapContainer)) {
            console.log('MAP in viewport')
            startLoadingMap();
            mapLoadingStart = true;
            clearTimeout(viewportTimer);
        }
    }, 1000);
    if (!mapLoadingStart && elementInViewport(mapContainer)) {
        console.log('MAP in viewport')
        startLoadingMap();
        mapLoadingStart = true;
        clearTimeout(viewportTimer);
    }

    // таймер добален для оптимизации
    let scrollTimer = null;
    window.addEventListener('scroll', function(event) {
        if(scrollTimer !== null) {
            clearTimeout(scrollTimer);
        }
        scrollTimer = setTimeout(function() {
            //resizeMap(mapContainer);

            if (!mapLoadingStart && elementInViewport(mapContainer)) {
                console.log('MAP in viewport')
                startLoadingMap();
                mapLoadingStart = true;
            }
            if ('undefined' !== typeof map) {
                map.container.fitToViewport()
                // если задан transition в css у родительского блока
                setTimeout(() => {map.container.fitToViewport()}, 300)
            }
        }, 100);
    }, true);

    if (!mapLoadingStart) {
        setTimeout(() => {
            console.log('MAP wait end');
            if (!mapLoadingStart) {
                startLoadingMap();
                mapLoadingStart = true;
            }
        }, 6000);
        console.log('MAP wait 6s');
    }
};

function resizeMap(element) {
    if (element && element.getBoundingClientRect().top < 40) {
        let newWidth = document.body.clientWidth - element.offsetLeft + 'px';
        if (element.style.width !== newWidth) {
            element.style.width = newWidth;
        }
    } else {
        if (element.style.width !== '100%') {
            element.style.width = '100%';
        }
    }
}

function startLoadingMap() {
    console.log('MAP start loading');
    let mapPromise = initMap(mapId, 1000);

    if ('undefined' === typeof App.clinicsData) {
        return;
    }
    mapPromise.then((result) => {
        map = result;
        let otherPlacemarks = [];
        let placemarks = new ymaps.GeoObjectCollection();

        window.map = map;

        for (const clinic of App.clinicsData) {
            let placemark = createClinicPLacemark(clinic);
            placemark.events.add('balloonopen', onPlacemarkOpen);
            placemark.events.add('balloonclose', onPlacemarkClose);
            placemark.properties.set('balloonContentUrl', clinic.balloonContentUrl)
            placemark.properties.set('balloonContent',
                '<div class="map-clinics-balloon clinic-card-preview"' +
                '   <div class="row">\n' +
                '       <div class="col">' +
                '           <div class="clinic-title rounded my-2 is-loading"></div>' +
                '           <div class="clinic-metros rounded my-2 is-loading"></div>' +
                '           <div class="clinic-phone rounded my-2 is-loading"></div>' +
                '           <div class="clinic-address rounded my-2 is-loading"></div>' +
                '       </div>' +
                '   </div>' +
                '</div>'
            );
            //placemarks.add(placemark);

            if (clinic.calculateCenter) {
                placemarks.add(placemark);
            } else {
                otherPlacemarks.push(placemark);
            }
        }

        map.geoObjects.add(placemarks);
        map.setBounds(placemarks.getBounds());

        otherPlacemarks.forEach((placemark) => {
            placemarks.add(placemark);
        });

        placemarks.options.set({
            balloonMaxWidth: 460,
        });

        bindClickOnMapLinks(map);
        bindClickOnClinicAddressLinks(map, placemarks);
        bindToCinicLinks();
    })
}

function onPlacemarkOpen(e) {
    const target = e.get('target');
    const clinicId = target.properties.get('clinicId');
    const balloonContentUrl = target.properties.get('balloonContentUrl');
    const requestBalloonContent = clinicMapBalloonContentQuery(balloonContentUrl);
    requestBalloonContent.then(async function(response) {
        const data = await response.json();
        if (data.success) {
            target.properties.set('balloonContent', data.result);
        }
    });
}

function onPlacemarkClose(e) {
    const target = e.get('target');
    const clinicId = target.properties.get('clinicId');
    const card = document.getElementById('clinic-card-' + clinicId)
    if (card !== null) {
        card.classList.remove('border-warning');
    }
}

function queryClinicCard(clinicId) {
    let data = {clinicId: clinicId};
    data[App.csrfParam] = App.csrfToken;
    const request = fetch(window.location.href, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(data).toString()
    });
    return request;
}

function addClinicCardPreview(clinicId) {
    let cardEl = document.createElement("div");
    cardEl.setAttribute('data-key', clinicId);
    cardEl.innerHTML = getClinicCardPreview();
    let container = document.getElementById('clinics-list');
    container.prepend(cardEl);
    return container.children.item(0);
}

function bindClickOnMapLinks(map) {
    document.addEventListener('click',(e) => {
        if(e.target && e.target.getAttribute('data-map-link') === 'true'){
            const longitude = parseFloat(e.target.getAttribute('data-longitude'));
            const latitude = parseFloat(e.target.getAttribute('data-latitude'));
            map.setZoom(14);
            map.panTo([longitude, latitude]);
        }
    });
}

function bindToCinicLinks(map) {
    const tabEl = document.querySelector('#clinics-container-tab')
    const tab = window.bootstrap.Tab.getOrCreateInstance(tabEl);
    document.addEventListener('click',(e) => {
        if(e.target && e.target.getAttribute('data-clinic-link') === 'true'){
            const clinicId = parseInt(e.target.getAttribute('data-clinic-id'));
            const card = document.getElementById('clinic-card-' + clinicId);
            tab.show();
            if (card !== null) {
                tab.show();
                card.classList.add('border-warning');
                setTimeout(function(){
                    card.scrollIntoView({block: "center"});
                }, 300);
            } else {
                const request = queryClinicCard(clinicId);
                const prevCard = addClinicCardPreview(clinicId);
                prevCard.children[0].classList.add('border-warning');
                setTimeout(function(){
                    prevCard.scrollIntoView({block: "center"});
                }, 300);

                request.then(async (response) => {
                    const result = await response.json();
                    const card = addClinicCard(prevCard, result.card);
                    card.children[0].classList.add('border-warning');
                });
            }
        }
    });
}

function bindClickOnClinicAddressLinks(map, placemarks) {
    const tabEl = document.querySelector('#clinic-map-tab')
    const tab = window.bootstrap.Tab.getOrCreateInstance(tabEl);
    document.addEventListener('click',(e) => {
        if(e.target && e.target.getAttribute('data-clinic-address') === 'true'){
            const clinicId = e.target.getAttribute('data-clinic-id');
            tab.show();
            placemarks.each((placemark) => {
                if (clinicId == placemark.properties.get('clinicId')) {
                    const coords = placemark.properties.get('coords');
                    map.setCenter([parseFloat(coords.lng), parseFloat(coords.lat)], 13);
                    placemark.balloon.open();
                    return false;
                }
            });

        }
    });
}

function bindBtnOpenMapTab() {
    const tabEl = document.querySelector('#clinic-map-tab')
    const tab = window.bootstrap.Tab.getOrCreateInstance(tabEl);
    document.addEventListener('click',(e) => {
        if(e.target && e.target.classList.contains('btn-open-map-tab')){
            tab.show();
        }
    });
}

function getClinicCardPreview() {
    const el = document.getElementById('clinic-card-preview');
    return el.innerHTML;
}

function clinicMapBalloonContentQuery(url) {
    const request = fetch(url, {
        method: 'GET',
    });
    return request;
}

export default run;